import DemoRenderer__LegacyDemoInstructions from '@runtime/DemoRenderer';
import InterfaceRenderer__LinkInstructions from '@runtime/TypescriptMetadataRenderer/interface';
import DemoRenderer__LinkInstructions from '@runtime/DemoRenderer';
import legacyImportDemo_664460638 from "../../../../../packages/component/src/components/menu/demo/demo1.js?loadDemo";
import legacyImportDemo_3608973341 from "../../../../../packages/component/src/components/menu/demo/demo2.js?loadDemo";
import legacyImportDemo_1817641948 from "../../../../../packages/component/src/components/menu/demo/demo3.js?loadDemo";
import legacyImportDemo_1107632986 from "../../../../../packages/component/src/components/menu/demo/demo5.js?loadDemo";
import legacyImportDemo_1573418186 from "../../../../../packages/component/src/components/menu/demo/demo-select.js?loadDemo";
import legacyImportDemo_3068459163 from "../../../../../packages/component/src/components/menu/demo/demo4.js?loadDemo";
import legacyImportDemo_2998228505 from "../../../../../packages/component/src/components/menu/demo/demo6.js?loadDemo";
import legacyImportDemo_2878936024 from "../../../../../packages/component/src/components/menu/demo/demo7.js?loadDemo";
import legacyImportDemo_411882135 from "../../../../../packages/component/src/components/menu/demo/demo8.js?loadDemo";
import * as React from 'react';
export default {
  DemoRenderer__LegacyDemoInstructions,
  InterfaceRenderer__LinkInstructions,
  DemoRenderer__LinkInstructions,
  legacyImportDemo_664460638,
  legacyImportDemo_3608973341,
  legacyImportDemo_1817641948,
  legacyImportDemo_1107632986,
  legacyImportDemo_1573418186,
  legacyImportDemo_3068459163,
  legacyImportDemo_2998228505,
  legacyImportDemo_2878936024,
  legacyImportDemo_411882135,
  React
};